import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import atf from "../../assets/AdvanceTaxFiling.png";
import services from "../../assets/individualTaxesServices.png";
import individual from "../../assets/individualTaxes.png";
import bt from "../../assets/BusinessTaxes.png";

export default function AdvanceTaxFiling() {
    useEffect(() => {
        AOS.init({ once: true, duration: 850, easing: "ease-in-out" });
    }, []);

    return (
        <div style={{ minHeight: "100vh", background: "#fff" }}>
            <div style={{ height: 72 }} /> {/* Header spacing */}

            {/* Hero Heading */}
            <section className="container py-5">
                <div className="row align-items-center" data-aos="fade-down">
                    <div className="col-lg-8">
                        <h1 className="fw-bold mb-3" style={{ 
                            fontFamily: "Poppins, sans-serif", 
                            color: "#6B46C1",
                            fontSize: "2.5rem"
                        }}>
                            Advance Tax Planning Services
                        </h1>
                        <h2 className="fw-bold mb-4" style={{ 
                            fontFamily: "Poppins, sans-serif", 
                            color: "#D53F8C",
                            fontSize: "1.75rem"
                        }}>
                            Stay Ahead. Stay Compliant. Save More.
                        </h2>
                        <div className="fs-5 text-secondary mb-4" style={{ lineHeight: "1.8" }}>
                            At NEXEN Consulting, our Advance Tax Planning services help individuals and businesses proactively manage their tax obligations throughout the year. Instead of waiting until tax season, we guide you in making strategic financial decisions that reduce your tax liability, maximize deductions, and keep you fully compliant with IRS regulations.
                        </div>
                    </div>
                    <div className="col-lg-4 text-center d-none d-lg-block" data-aos="zoom-in">
                        <img
                            src={atf}
                            alt="Advance Tax Planning"
                            className="rounded-4 shadow-lg"
                            style={{ width: "100%", maxWidth: "400px" }}
                        />
                    </div>
                </div>
            </section>

            {/* Why Advance Tax Planning Is Essential */}
            <section className="container py-5" data-aos="fade-up">
                <div className="text-center mb-5">
                    <h2 className="fw-bold mb-3" style={{ 
                        color: "#6B46C1", 
                        fontFamily: "Poppins, sans-serif",
                        fontSize: "2rem"
                    }}>
                        Why Advance Tax Planning Is Essential
                    </h2>
                </div>
                <div className="row g-4">
                    <div className="col-md-6 col-lg-4">
                        <div className="card border-0 shadow-sm h-100" style={{
                            background: "linear-gradient(135deg, #edeaff 0%, #fff5fb 100%)",
                            borderRadius: "1rem",
                            transition: "transform 0.3s ease"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{
                                        width: "50px",
                                        height: "50px",
                                        background: "linear-gradient(90deg, #6B46C1, #D53F8C)",
                                        color: "#fff"
                                    }}>
                                        <span className="fw-bold fs-4">1</span>
                                    </div>
                                    <h5 className="fw-bold mb-0" style={{ color: "#6B46C1" }}>
                                        Avoid Unexpected Tax Bills
                                    </h5>
                                </div>
                                <p className="text-secondary mb-0" style={{ lineHeight: "1.7" }}>
                                    We estimate your annual tax liability and help you plan quarterly payments to avoid penalties, interest, and last-minute stress.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <div className="card border-0 shadow-sm h-100" style={{
                            background: "linear-gradient(135deg, #fff5fb 0%, #edeaff 100%)",
                            borderRadius: "1rem",
                            transition: "transform 0.3s ease"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{
                                        width: "50px",
                                        height: "50px",
                                        background: "linear-gradient(90deg, #6B46C1, #D53F8C)",
                                        color: "#fff"
                                    }}>
                                        <span className="fw-bold fs-4">2</span>
                                    </div>
                                    <h5 className="fw-bold mb-0" style={{ color: "#6B46C1" }}>
                                        Legally Reduce Your Tax Burden
                                    </h5>
                                </div>
                                <p className="text-secondary mb-0" style={{ lineHeight: "1.7" }}>
                                    Our experts identify eligible deductions, credits, and tax-saving opportunities tailored to your income, business activities, and financial goals.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <div className="card border-0 shadow-sm h-100" style={{
                            background: "linear-gradient(135deg, #edeaff 0%, #fff5fb 100%)",
                            borderRadius: "1rem",
                            transition: "transform 0.3s ease"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{
                                        width: "50px",
                                        height: "50px",
                                        background: "linear-gradient(90deg, #6B46C1, #D53F8C)",
                                        color: "#fff"
                                    }}>
                                        <span className="fw-bold fs-4">3</span>
                                    </div>
                                    <h5 className="fw-bold mb-0" style={{ color: "#6B46C1" }}>
                                        Better Cash Flow Management
                                    </h5>
                                </div>
                                <p className="text-secondary mb-0" style={{ lineHeight: "1.7" }}>
                                    By forecasting taxes in advance, you can prepare budgets, manage expenses, and maintain smooth financial operations all year round.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <div className="card border-0 shadow-sm h-100" style={{
                            background: "linear-gradient(135deg, #fff5fb 0%, #edeaff 100%)",
                            borderRadius: "1rem",
                            transition: "transform 0.3s ease"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{
                                        width: "50px",
                                        height: "50px",
                                        background: "linear-gradient(90deg, #6B46C1, #D53F8C)",
                                        color: "#fff"
                                    }}>
                                        <span className="fw-bold fs-4">4</span>
                                    </div>
                                    <h5 className="fw-bold mb-0" style={{ color: "#6B46C1" }}>
                                        Optimize Your Business Structure
                                    </h5>
                                </div>
                                <p className="text-secondary mb-0" style={{ lineHeight: "1.7" }}>
                                    We evaluate whether your current entity type—LLC, S-Corp, partnership, or sole proprietorship—offers the best tax benefits and recommend adjustments where needed.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <div className="card border-0 shadow-sm h-100" style={{
                            background: "linear-gradient(135deg, #edeaff 0%, #fff5fb 100%)",
                            borderRadius: "1rem",
                            transition: "transform 0.3s ease"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{
                                        width: "50px",
                                        height: "50px",
                                        background: "linear-gradient(90deg, #6B46C1, #D53F8C)",
                                        color: "#fff"
                                    }}>
                                        <span className="fw-bold fs-4">5</span>
                                    </div>
                                    <h5 className="fw-bold mb-0" style={{ color: "#6B46C1" }}>
                                        Plan for Major Financial Events
                                    </h5>
                                </div>
                                <p className="text-secondary mb-0" style={{ lineHeight: "1.7" }}>
                                    From real estate sales and investments to retirement contributions and capital gains, we help you plan timing and strategy for maximum tax efficiency.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <div className="card border-0 shadow-sm h-100" style={{
                            background: "linear-gradient(135deg, #edeaff 0%, #fff5fb 100%)",
                            borderRadius: "1rem",
                            transition: "transform 0.3s ease"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{
                                        width: "50px",
                                        height: "50px",
                                        background: "linear-gradient(90deg, #6B46C1, #D53F8C)",
                                        color: "#fff"
                                    }}>
                                        <span className="fw-bold fs-4">6</span>
                                    </div>
                                    <h5 className="fw-bold mb-0" style={{ color: "#6B46C1" }}>
                                        Tax Advantage Saving Plans
                                    </h5>
                                </div>
                                <p className="text-secondary mb-0" style={{ lineHeight: "1.7" }}>
                                    We help you reduce your tax liability, primarily through retirement, health and education savings accounts.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* What Our Tax Planning Covers */}
            <section className="container py-5" data-aos="fade-up">
                <div className="text-center mb-5">
                    <h2 className="fw-bold mb-3" style={{ 
                        color: "#6B46C1", 
                        fontFamily: "Poppins, sans-serif",
                        fontSize: "2rem"
                    }}>
                        What Our Tax Planning Covers
                    </h2>
                </div>
                <div className="row g-4">
                    {/* For Individuals */}
                    <div className="col-lg-6">
                        <div className="card border-0 shadow-lg h-100" style={{
                            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                            borderRadius: "1.5rem"
                        }}>
                            <div className="card-body text-white p-5">
                                <h3 className="fw-bold mb-4" style={{ fontFamily: "Poppins, sans-serif" }}>
                                    For Individuals
                                </h3>
                                <ul className="list-unstyled" style={{ lineHeight: "2" }}>
                                    <li className="mb-2">
                                        <i className="bi bi-check-circle-fill me-2"></i>Income estimation & projections
                                    </li>
                                    <li className="mb-2">
                                        <i className="bi bi-check-circle-fill me-2"></i>Withholding adjustments (Form W-4 guidance)
                                    </li>
                                    <li className="mb-2">
                                        <i className="bi bi-check-circle-fill me-2"></i>Retirement contribution planning (IRA)
                                    </li>
                                    <li className="mb-2">
                                        <i className="bi bi-check-circle-fill me-2"></i>Health savings account (HSA) planning
                                    </li>
                                    <li className="mb-2">
                                        <i className="bi bi-check-circle-fill me-2"></i>Capital gains optimization
                                    </li>
                                    <li className="mb-2">
                                        <i className="bi bi-check-circle-fill me-2"></i>Tax-advantaged savings strategies
                                    </li>
                                    <li className="mb-2">
                                        <i className="bi bi-check-circle-fill me-2"></i>Deduction & credit maximization
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* For Businesses */}
                    <div className="col-lg-6">
                        <div className="card border-0 shadow-lg h-100" style={{
                            background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                            borderRadius: "1.5rem"
                        }}>
                            <div className="card-body text-white p-5">
                                <h3 className="fw-bold mb-4" style={{ fontFamily: "Poppins, sans-serif" }}>
                                    For Businesses
                                </h3>
                                <ul className="list-unstyled" style={{ lineHeight: "2" }}>
                                    <li className="mb-2">
                                        <i className="bi bi-check-circle-fill me-2"></i>Quarterly estimated tax planning
                                    </li>
                                    <li className="mb-2">
                                        <i className="bi bi-check-circle-fill me-2"></i>Expense planning & depreciation strategy
                                    </li>
                                    <li className="mb-2">
                                        <i className="bi bi-check-circle-fill me-2"></i>Payroll vs distribution strategy for owners
                                    </li>
                                    <li className="mb-2">
                                        <i className="bi bi-check-circle-fill me-2"></i>Business entity tax optimization
                                    </li>
                                    <li className="mb-2">
                                        <i className="bi bi-check-circle-fill me-2"></i>Cash flow forecasting
                                    </li>
                                    <li className="mb-2">
                                        <i className="bi bi-check-circle-fill me-2"></i>Record-keeping and documentation guidance
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Who Can Benefit */}
            <section className="container py-5" data-aos="fade-up">
                <div className="row align-items-center">
                    <div className="col-lg-6 mb-4 mb-lg-0">
                        <img
                            src={services}
                            alt="Tax Planning Services"
                            className="rounded-4 shadow-lg"
                            style={{ width: "100%", maxWidth: "500px" }}
                            data-aos="zoom-in"
                        />
                    </div>
                    <div className="col-lg-6">
                        <h2 className="fw-bold mb-4" style={{ 
                            color: "#D53F8C", 
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "2rem"
                        }}>
                            Who Can Benefit?
                        </h2>
                        <div className="row g-3">
                            <div className="col-md-6">
                                <div className="d-flex align-items-start mb-3">
                                    <i className="bi bi-person-check-fill me-3 fs-4" style={{ color: "#6B46C1" }}></i>
                                    <span className="text-secondary">Self-employed professionals</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="d-flex align-items-start mb-3">
                                    <i className="bi bi-briefcase-fill me-3 fs-4" style={{ color: "#6B46C1" }}></i>
                                    <span className="text-secondary">Freelancers & consultants</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="d-flex align-items-start mb-3">
                                    <i className="bi bi-building me-3 fs-4" style={{ color: "#6B46C1" }}></i>
                                    <span className="text-secondary">Small and medium business owners</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="d-flex align-items-start mb-3">
                                    <i className="bi bi-graph-up-arrow me-3 fs-4" style={{ color: "#6B46C1" }}></i>
                                    <span className="text-secondary">High-income individuals</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="d-flex align-items-start mb-3">
                                    <i className="bi bi-wallet2 me-3 fs-4" style={{ color: "#6B46C1" }}></i>
                                    <span className="text-secondary">Anyone with multiple income sources</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="d-flex align-items-start mb-3">
                                    <i className="bi bi-house-door-fill me-3 fs-4" style={{ color: "#6B46C1" }}></i>
                                    <span className="text-secondary">Investors expecting capital gains or property sales</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Why Choose NEXEN Consulting */}
            <section className="container py-5" data-aos="fade-up">
                <div className="row align-items-center">
                    <div className="col-lg-6 order-lg-1 order-2">
                        <h2 className="fw-bold mb-4" style={{ 
                            color: "#6B46C1", 
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "2rem"
                        }}>
                            Why Choose NEXEN Consulting?
                        </h2>
                        <div className="row g-3">
                            <div className="col-12">
                                <div className="d-flex align-items-start">
                                    <i className="bi bi-award-fill me-3 fs-4 mt-1" style={{ color: "#D53F8C" }}></i>
                                    <div>
                                        <h6 className="fw-bold mb-1" style={{ color: "#344476" }}>Expert guidance from certified US tax professionals</h6>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="d-flex align-items-start">
                                    <i className="bi bi-person-badge me-3 fs-4 mt-1" style={{ color: "#D53F8C" }}></i>
                                    <div>
                                        <h6 className="fw-bold mb-1" style={{ color: "#344476" }}>Personalized tax strategies tailored to your unique situation</h6>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="d-flex align-items-start">
                                    <i className="bi bi-calendar-check me-3 fs-4 mt-1" style={{ color: "#D53F8C" }}></i>
                                    <div>
                                        <h6 className="fw-bold mb-1" style={{ color: "#344476" }}>Year-round support — not just during tax season</h6>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="d-flex align-items-start">
                                    <i className="bi bi-eye-fill me-3 fs-4 mt-1" style={{ color: "#D53F8C" }}></i>
                                    <div>
                                        <h6 className="fw-bold mb-1" style={{ color: "#344476" }}>Transparent process with clear, actionable insights</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 order-lg-2 order-1 mb-4 mb-lg-0 text-center">
                        <img
                            src={individual}
                            alt="NEXEN Consulting"
                            className="rounded-4 shadow-lg"
                            style={{ width: "100%", maxWidth: "500px" }}
                            data-aos="zoom-in"
                        />
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="py-5 my-5" style={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                borderRadius: "2rem"
            }}>
                <div className="container text-center text-white">
                    <h2 className="fw-bold mb-3" style={{ 
                        fontFamily: "Poppins, sans-serif",
                        fontSize: "2rem"
                    }}>
                        Get Started Today
                    </h2>
                    <p className="lead mb-4 fs-5" style={{ opacity: 0.95, lineHeight: "1.8" }}>
                        Proactive tax planning can save you thousands each year.<br />
                        Let NEXEN Consulting help you stay compliant and confidently maximize your tax savings.
                    </p>
                    <Link
                        to="/contact"
                        className="btn btn-light btn-lg rounded-pill fw-bold px-5 py-3"
                        style={{
                            background: "#fff",
                            color: "#6B46C1",
                            border: "none",
                            boxShadow: "0 4px 15px rgba(255, 255, 255, 0.3)",
                            transition: "transform 0.3s ease, box-shadow 0.3s ease"
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "scale(1.05)";
                            e.currentTarget.style.boxShadow = "0 8px 30px rgba(255, 255, 255, 0.5)";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "scale(1)";
                            e.currentTarget.style.boxShadow = "0 4px 15px rgba(255, 255, 255, 0.3)";
                        }}
                    >
                        Get in Touch
                    </Link>
                </div>
            </section>
        </div>
    );
}
